module.exports = require("dompurify");


//////////////////
// WEBPACK FOOTER
// external "dompurify"
// module id = 648
// module chunks = 0